<template>
  <div class="container">
    <div class="text-lg font-semibold">Password Berubah</div>
    <span>Silahkan cek email anda untuk reset password</span>
  </div>
</template>
